import React, { useState } from 'react';
import { 
  Close,
} from '@mui/icons-material';
import DandDAPI from '@utilities/smart_api';
import FlexBox from '@components/layout/FlexBox';
import InfoButton from './buttons/InfoButton';

interface Props {
  label?: string;
  info_name: string;
  children?: React.ReactNode;
}

const api = DandDAPI.getInstance();

export default function InfoBox({ 
  label = "",
  info_name,
  children,
}: Props) {
  const [display_info, setDisplayInfo] = useState(api.user ? !api.user.hide_info.includes(info_name) : true);

  const toggleInfo = () => {
    const user = api.user;
    if (user) {
      if (display_info) {
        user.hide_info.push(info_name);
      } else {
        user.hide_info = user.hide_info.filter(o => o !== info_name);
      }

      api.upsertObject("user", user);
    }
    setDisplayInfo(!display_info);
  }

  return (
    <FlexBox direction="column">
      <FlexBox className="header centered">
        {label}
        <InfoButton onClick={toggleInfo} />
      </FlexBox>
      { display_info && 
        <FlexBox direction="column" className="info-box">
          <FlexBox xs_expand={0}>
            <div className="clickable float-right" onClick={toggleInfo}>
              <Close />
            </div>
          </FlexBox>
          <FlexBox>
            { children }
          </FlexBox>
        </FlexBox>
      }
    </FlexBox>
  )
}